import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app__nav-left" }
const _hoisted_2 = ["tabindex", "aria-label"]
const _hoisted_3 = { class: "app__nav-logo" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "app__nav-progress" }
const _hoisted_6 = { class: "app__nav-right" }
const _hoisted_7 = ["aria-label", "tabindex"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = {
  key: 2,
  class: "share__modal"
}
const _hoisted_11 = { class: "share__title" }
const _hoisted_12 = { class: "share__subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "share__socials"
}
const _hoisted_14 = ["aria-label", "href"]
const _hoisted_15 = ["aria-label", "href"]
const _hoisted_16 = ["aria-label", "href"]
const _hoisted_17 = ["aria-label", "href"]
const _hoisted_18 = { class: "share__embed" }
const _hoisted_19 = { class: "share__embed-code" }
const _hoisted_20 = { class: "share__embed-button-wrapper" }
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "overlay" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "share__embed-message share__embed-message--succes"
}
const _hoisted_24 = {
  key: 1,
  class: "share__embed-message share__embed-message--fail"
}
const _hoisted_25 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RSInject = _resolveComponent("RSInject")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["app__nav", {
      'app__nav--hidden': $setup.hideNav,
      'app__nav--choices-overview': $setup.route.name === 'choices-overview',
      'with-ad': $setup.config.settings.showAd,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["button button--back", { 'button--disabled': $setup.disableNavButtons }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.back && $setup.back(...args))),
        tabindex: $setup.disableNavButtons ? '-1' : '0',
        "aria-label": $setup.dictionary.app.accessibility.back
      }, null, 10, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          alt: $setup.dictionary.app.logoAlt,
          src: 'gfx/img/' + $setup.config.style.logo
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", {
        class: "app__nav-progress-indicator",
        style: _normalizeStyle('width: ' + $setup.indicatorWidth + '%')
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      ($setup.config.settings.showReadSpeaker)
        ? (_openBlock(), _createBlock(_component_RSInject, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["app__nav-counter", {
          'app__nav-counter--hidden':
            $setup.route.name === 'results' || $setup.route.name === 'choices-overview',
        }])
      }, [
        _createElementVNode("strong", null, _toDisplayString($setup.route.name === "start"
              ? "1"
              : $setup.route.name === "statement" ||
                  $setup.route.name === "shootout-statement"
                ? $setup.route.params.id
                : Object.values($setup.statements).length) + "/", 1),
        _createTextVNode(_toDisplayString($setup.route.name === "shootout-statement"
            ? Object.values($setup.shootoutStatements).length
            : Object.values($setup.statements).length), 1)
      ], 2),
      ($setup.config.settings.showShareMenu)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["app__nav-share-button button button--share", {
          'button--disabled': $setup.disableNavButtons,
          'app__nav-share-button--hidden': $setup.route.name === 'results',
        }]),
            "aria-label": 
          $setup.dictionary.app.accessibility.shareButtonName +
          ($setup.shareModalOpen
            ? ', ' + $setup.dictionary.app.accessibility.opened
            : ', ' + $setup.dictionary.app.accessibility.closed)
        ,
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.shareModalOpen = !$setup.shareModalOpen)),
            tabindex: $setup.disableNavButtons ? '-1' : '0'
          }, null, 10, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: $setup.config.style.clientLogoUrl,
        target: "_blank",
        rel: "nofollow",
        class: "app__nav-client-logo"
      }, [
        _createElementVNode("img", {
          alt: $setup.dictionary.app.clientLogoAlt,
          src: 'gfx/img/' + $setup.config.style.clientLogoBlack
        }, null, 8, _hoisted_9)
      ], 8, _hoisted_8),
      ($setup.shareModalOpen)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString($setup.shareTitle), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString($setup.shareSubtitle), 1),
            ($setup.showShareButtons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (
              $setup.route.name === 'statement'
                ? $setup.dictionary.statement.share?.facebookWithStatement
                : $setup.dictionary.app.share.facebook
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "share__social-button share__social-button--facebook",
                        "aria-label": $setup.dictionary.app.share.accessibility.facebookButtonLabel,
                        tabindex: "0",
                        href: $setup.shareLink('facebook'),
                        target: "_blank"
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (
              $setup.route.name === 'statement'
                ? $setup.dictionary.statement.share?.twitterWithStatement
                : $setup.dictionary.app.share.twitter
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "share__social-button share__social-button--twitter",
                        "aria-label": $setup.dictionary.app.share.accessibility.twitterButtonLabel,
                        tabindex: "0",
                        href: $setup.shareLink('twitter'),
                        target: "_blank"
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (
              $setup.route.name === 'statement'
                ? $setup.dictionary.statement.share?.linkedinWithStatement
                : $setup.dictionary.app.share.linkedin
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "share__social-button share__social-button--linkedin",
                        "aria-label": $setup.dictionary.app.share.accessibility.linkedinButtonLabel,
                        tabindex: "0",
                        href: $setup.shareLink('linkedin'),
                        target: "_blank"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (
              $setup.route.name === 'statement'
                ? $setup.dictionary.statement.share?.whatsappWithStatement
                : $setup.dictionary.app.share.whatsapp
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        class: "share__social-button share__social-button--whatsapp",
                        "aria-label": $setup.dictionary.app.share.accessibility.whatsappButtonLabel,
                        tabindex: "0",
                        href: $setup.shareLink('whatsapp'),
                        target: "_blank"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString($setup.embedCode), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "share__embed-button",
                  "aria-label": $setup.dictionary.app.share.copyEmbedCode,
                  tabindex: "0",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.copyEmbedCode && $setup.copyEmbedCode(...args)))
                }, [
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString($setup.dictionary.app.share.copyEmbedCode), 1)
                ], 8, _hoisted_21),
                ($setup.shareSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.dictionary.app.share.copyEmbedCodeSucces), 1))
                  : _createCommentVNode("", true),
                ($setup.shareFail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.dictionary.app.share.copyEmbedCodeFail), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "share__close",
              "aria-label": $setup.dictionary.app.closeModal,
              tabindex: "0",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.shareModalOpen = false))
            }, _toDisplayString($setup.dictionary.app.closeModal), 9, _hoisted_25)
          ])), [
            [_directive_click_away, () => ($setup.shareModalOpen = false)]
          ])
        : _createCommentVNode("", true)
    ])
  ], 2))
}